import { Injectable, OnDestroy } from '@angular/core';
import {
    IAnswer,
    IQuestion,
    IQuestionnaire,
    ISubmitQuestionnaire,
    IGratitude,
} from '@shared/models';
import { Observable, take, AsyncSubject, BehaviorSubject } from 'rxjs';
import { PATH } from 'src/app/config/path.configs';
import { RestApiService } from './rest-api.service';

@Injectable({
    providedIn: 'root',
})
export class QuestionnaireService implements OnDestroy {
    public questionnaireSubject = new AsyncSubject<IQuestionnaire>();
    public activeBatteryId$ = new BehaviorSubject<string | null | undefined>(
        null
    );

    constructor(private readonly restApi: RestApiService) {}

    public ngOnDestroy(): void {
        this.questionnaireSubject.unsubscribe();
        this.activeBatteryId$.unsubscribe();
    }

    public fetchQuestionnaire(questionnaireId: string, lang: string | null = null): void {
        const url = `${PATH.QUESTIONNAIRE}/${questionnaireId}`
        this.restApi
            .get<IQuestionnaire>(url, {params: lang ? { lang } : {}})
            .pipe(take(1))
            .subscribe(
                questionnaire => {
                    this.questionnaireSubject.next(questionnaire);
                    this.questionnaireSubject.complete();
                },
                error => {
                    this.questionnaireSubject.next(error);
                    this.questionnaireSubject.complete();
                }
            );
    }

    public changeStatusQuestionnaire(
        questionnaireId: string,
        body: ISubmitQuestionnaire
    ): Observable<null> {
        return this.restApi.put(
            `${PATH.QUESTIONNAIRE}/${questionnaireId}`,
            body
        );
    }

    public submitQuestionnaire(
        questionnaireId: string,
        phoneCaller: string,
        body: ISubmitQuestionnaire
    ): Observable<null> {

        let apiPath = `${PATH.QUESTIONNAIRE}/${questionnaireId}`

        if(phoneCaller){
            apiPath = `${PATH.QUESTIONNAIRE}/${questionnaireId}?phoneCaller=${phoneCaller}`
        }
        return this.restApi.post(
            apiPath,
            body
        );
    }

    public getGratitude(questionnaireId: string, languageCode: string): Observable<IGratitude> {
        var url = `${PATH.QUESTIONNAIRE}/${questionnaireId}/${PATH.GRATITUDE}`
        if(languageCode){
            url = url + `?lang=${languageCode}`
        }
        return this.restApi
            .get<IGratitude>(
                url
            )
            .pipe(take(1));
    }

    public getQuestionById(
        questionnaireId: string,
        questionId: string,
        languageCode: string
    ): Observable<IQuestion> {
        var url = `${PATH.QUESTIONNAIRE}/${questionnaireId}/${PATH.QUESTION}/${questionId}`
        
        if(languageCode){
            url = url + `?lang=${languageCode}`
        }

        return this.restApi
            .get<IQuestion>(
                url
            )
            .pipe(take(1));
    }

    public submitAnswerbyQuestion(
        questionnaireId: string,
        questionId: string,
        body: IAnswer
    ): Observable<IAnswer | null> {
        return this.restApi
            .post<IAnswer>(
                `${PATH.QUESTIONNAIRE}/${questionnaireId}/${PATH.QUESTION}/${questionId}/${PATH.ANSWER}`,
                body
            )
            .pipe(take(1));
    }

    public getAnswerQuestionById(
        questionnaireId: string,
        questionId: string,
        languageCode: string
    ): Observable<IAnswer> {
        var url = `${PATH.QUESTIONNAIRE}/${questionnaireId}/${PATH.QUESTION}/${questionId}/${PATH.ANSWER}`

        if(languageCode){
            url = url + `?lang=${languageCode}`
        }
        return this.restApi
            .get<IAnswer>(
                url
            )
            .pipe(take(1));
    }
}
